import { Icon, type IconProps } from './PlatformIcons.tsx';

/**
 * Le icone della navigazione dell'ente e del volontario.
 *
 * Lo stesso principio di `PlatformIcons.tsx`, di cui riusano l'involucro
 * (`currentColor`, `aria-hidden`, `focusable="false"`): il nome accessibile
 * di ogni voce resta la sua etichetta tradotta, mai l'icona.
 *
 * Prima queste voci non ne avevano — solo quelle del fornitore, otto
 * pulsanti su un pannello a parte. Il resto della barra restava testo su
 * testo, ed è una delle ragioni per cui il restyling sembrava ancora la
 * vecchia barra con un colore diverso addosso (`docs/DECISIONI.md`, BP3).
 */

/** La console: una cuffia, il turno d'ascolto. */
export function ConsoleIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4.5 13v-1a7.5 7.5 0 0 1 15 0v1" />
      <rect x="3" y="13" width="4" height="6" rx="1.5" />
      <rect x="17" y="13" width="4" height="6" rx="1.5" />
      <path d="M19.5 19v.5a2 2 0 0 1-2 2h-2.5" />
    </Icon>
  );
}

/** I turni: un calendario con le due alette dell'anello. */
export function ShiftsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M3.5 9.5h17" />
      <path d="M8 3v4M16 3v4" />
    </Icon>
  );
}

/** Le notifiche: una campana, con il battaglio in vista. */
export function NotificationsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 3a1 1 0 0 1 1 1v.6a6 6 0 0 1 5 5.9v3.6l1.4 2.2a1 1 0 0 1-.9 1.5H5.5a1 1 0 0 1-.9-1.5L6 14.1v-3.6a6 6 0 0 1 5-5.9V4a1 1 0 0 1 1-1Z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </Icon>
  );
}

/** L'avvio guidato: una bandierina, il primo passo segnato. */
export function OnboardingIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M6 21V3" />
      <path d="M6 4.5h12l-3 3.5 3 3.5H6" />
    </Icon>
  );
}

/** La supervisione: uno scudo, chi risponde protetto da chi lo affianca. */
export function SupervisionIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 3.25 19 6v5c0 5-3 8.5-7 9.75-4-1.25-7-4.75-7-9.75V6l7-2.75Z" />
      <path d="M9 12l2 2 4-4.5" />
    </Icon>
  );
}

/** Le segnalazioni: un triangolo d'avviso, un solo punto da leggere. */
export function ModerationIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12 3.5 21 19.5H3L12 3.5Z" />
      <path d="M12 9.5v4.25" />
      <path d="M12 16.75h.01" />
    </Icon>
  );
}

/** Orari e turni dell'ente: un orologio. */
export function HoursIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3.2 1.9" />
    </Icon>
  );
}

/** La rendicontazione: tre barre, un totale. */
export function ReportIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4.5 20v-6.5" />
      <path d="M10.5 20V6" />
      <path d="M16.5 20v-9.5" />
      <path d="M3 20h18" />
    </Icon>
  );
}

/** L'aspetto del widget: quattro tessere, la tavolozza dei colori. */
export function WidgetIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="4" y="4" width="7" height="7" rx="1.5" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" />
    </Icon>
  );
}

/** I documenti: un foglio con l'angolo piegato. */
export function DocumentsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M6.5 3.5h7.5l4.5 4.5V20a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z" />
      <path d="M14 3.5V8h4.5" />
      <path d="M8.5 13h7M8.5 16.5h5" />
    </Icon>
  );
}

/** La rete: tre enti collegati allo stesso referente. */
export function NetworkIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="6" cy="6.5" r="2.25" />
      <circle cx="18" cy="6.5" r="2.25" />
      <circle cx="12" cy="18" r="2.25" />
      <path d="M7.8 8 10.5 16M16.2 8 13.5 16" />
    </Icon>
  );
}
